export const ORDER_DETAIL = 'ORDER_DETAIL'
export const DELETE_PERFORM = 'DELETE_PERFORM'
export const DELETE_ORDER = 'DELETE_ORDER'
export const SELECT_COUPON = 'SELECT_COUPON'
export const UPDATE_USER = 'UPDATE_USER'
export const CLEAR_ORDER = 'CLEAR_ORDER'



// WEBPACK FOOTER //
// ./src/store/order/mutation-types.js